<template>
  <span class="d-flex flex-row align-center">
    <v-img :src="iconForType" :max-width="width" :eager="eager" />
    <span class="" :class="labelClass" v-if="showLabel">{{ label }}</span>
  </span>
</template>

<script>
import FilterDictionary from "@/assets/js/cls/FilterDictionary";

export default {
  name: "SoftTypeIcon",
  props: {
    lens: {},
    width: {
      type: Number,
      default: 26,
    },
    type: {
      type: String,
      default: "type", // "type" for bifocal/sphere/toric etc, "replace" for daily, 2 week, etc.
    },
    active: {
      type: Boolean,
      default: true,
    },
    eager: {
      type: Boolean,
      default: false,
    },
    showLabel: { type: Boolean, default: false },
    labelClass: {
      type: String,
      default: "ml-3 text-h4 grey--text text--darken-3",
    },
  },
  data: () => ({
    path: {
      type: "/images/icons/lensTypes/",
      replace: "/images/icons/replace/",
    },
  }),
  computed: {
    typeFile: function () {
      // let icon = "";
      //  careful - these strings need to be concatenated in the right order to match the file names
      // if (this.lens.cosmetic == "1") icon += "cosmetic_";
      // if (this.lens.bifocal == "1") icon += "bifocal_";
      // icon += this.lens.toric == "1" ? "toric_" : "sphere_";
      // icon += "icon";
      if (!this.lens.type_tag) return null;
      let icon = `${this.lens.type_tag.toLowerCase()}_icon`;
      if (this.active) icon += "_active";
      return icon + ".svg";
    },
    replaceFile: function () {
      let icon = "";
      if (this.lens.replace > 0) {
        icon = "replace_" + this.lens.replace;
        if (this.active) icon += "_active";
        return icon + ".svg";
      }
      return icon;
    },
    iconForType: function () {
      let icon = this.type == "type" ? this.typeFile : this.replaceFile;
      return this.path[this.type] + icon;
    },
    label: function () {
      if (!this.showLabel) return null;
      let label = "";
      if (this.type == "type")
        label = FilterDictionary.parameterValueForLensType(
          this.lens.type_tag,
          "label"
        );
      if (this.type == "replace" && this.lens.replace) {
        label = FilterDictionary.replaceTitleForDays(this.lens.replace);
      }
      return label;
    },
  },
};
</script>

<style scoped></style>
